import * as Yup from 'yup';
import { DocumentTypesEnum_class } from '../../../../../common/enums/documentTypes';

export interface ResourceDto {
    id?: string,
    typeId: number,
    name: string,
    documentTypeId: number,
    documentType?: string,
    fileUrl: string,
    isActive: boolean,
    createdOn: Date,
    uploadedBy: string
    file?: ResourceUploadDto,
    isFile: boolean,
    isUrl: boolean,
    fileUpload?: File[],
}

export interface ResourceUploadDto {
    id?: string;
    facilityResourceId: string;
    uploadFileName: string;
    uploadFilePath: string;
    mimeType: string;
}

export const resourceInit: ResourceDto = {
    id: '',
    typeId: 0,
    name: '',
    documentTypeId: 0,
    fileUrl: '',
    createdOn: new Date(),
    uploadedBy: '',
    isActive: true,
    isFile: false,
    isUrl: false,
    fileUpload: [],
}

export const resourcesValidationSchema = Yup.object().shape({
    name: Yup.string().required("Please enter a file name."),
    documentTypeId: Yup.mixed().oneOf(Object.values(DocumentTypesEnum_class.enum), 'Please select a document type.').required('Please select a document type.'),
    fileUrl: Yup.string()
        .url("Must be a valid url. Please include http:// or https:// in the url")
        .when('isUrl', {
            is: true,
            then: Yup.string()
            .required('Please enter a URL.'),
            otherwise: Yup.string(),
        }),
     fileUpload: Yup.array().when('isFile', {
        is: true,
        then: Yup.array().min(1, 'Please select a file.'),
        otherwise: Yup.array(),
     }),
});